import React from 'react';
import DisplayBaseTabContent from 'modules/Layout/view/Details/Helper/DisplayBaseTabContent';
import Table, { TableCol } from 'modules/Layout/component/Table';
import { getPathUrl } from 'modules/Shared/helper/api';
import { HelpFindPlantEntity } from 'modules/Plants/model/HelpFindPlant';
import { HealthCheckHelpEntity } from 'modules/PlantDiseases/model/HealthCheckHelp';
import { ROUTE_HEALTH_CHECK_HELP_DETAILS } from 'modules/PlantDiseases/routes';

export interface Props {
  healthCheck: HealthCheckHelpEntity[];
}

const UserDetailsHelpHealthCheck = (props: Props): JSX.Element => {
  const { healthCheck } = props;

  const cols: TableCol<HelpFindPlantEntity>[] = [
    {
      label: 'Sent at',
      property: 'created_at',
      columnRedirectTo: (row) =>
        getPathUrl(ROUTE_HEALTH_CHECK_HELP_DETAILS, { id: row.id })
    }
  ];

  return (
    <div className="content restrict-width">
      <DisplayBaseTabContent title="Help health check">
        <Table cols={cols} rows={healthCheck} />
      </DisplayBaseTabContent>
    </div>
  );
};

export default UserDetailsHelpHealthCheck;
